import React, { useState } from "react";
import { Stack } from "@mui/system";
import { Button, Typography } from "@mui/material";

export interface CreateEventStepperProps {
  steps: {
    stepTitle: string;
    stepImage: string;
    stepHeading: string;
    stepColor: string;
    stepFont: string;
    stepDescription: string;
  }[];
}

const CreateEventStepper = ({ steps }: CreateEventStepperProps) => {
  const [showDetail, setShowDetails] = useState(0);
  return (
    <Stack direction="row" width="100%">
      {steps.map((step: any, index: any) => {
        return (
          <Stack>
            <Stack
              borderRadius={
                index === 0
                  ? "20px 0px 0px 20px"
                  : index === steps.length - 1 ? "0px 20px 20px 0px" : 0
              }
              height="720px"
              display={showDetail === index ? "flex" : "none"}
              p={8}
              style={{
                background: `linear-gradient(to bottom, rgba(18, 18, 18, 0), rgba(18, 18, 18, 1)),
              url(${step.stepImage})`,
                backgroundSize: "cover",
                backgroundRepeat: " no-repeat",
                backgroundPosition: "center"
              }}
            >
              <Stack flex={1} justifyContent="flex-end" spacing={3.5}>
                <Typography
                  className="font-white"
                  variant="h3"
                  fontWeight={700}
                  textTransform="uppercase"
                >
                  <span style={{ textDecoration: "underline" }}>{`Step ${index + 1}:`}</span>{` ${step.stepTitle}`}
                </Typography>
                <Stack spacing={1.3}>
                  <Typography
                    className="font-primary"
                    variant="h4"
                    fontWeight={700}
                  >
                    {step.stepHeading}
                  </Typography>
                  <Typography className="font-white" fontSize={16}>
                    {step.stepDescription}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            {showDetail !== index &&
              <Stack
                className={`background-${step.stepColor}`}
                pb={4}
                height="100%"
                borderRadius={
                  index === 0
                    ? "20px 0px 0px 20px"
                    : index === steps.length - 1 ? "0px 20px 20px 0px" : 0
                }
                px={2}
              >
                <Button
                  onClick={() => setShowDetails(index)}
                  style={{ height: "100%", alignItems: "flex-end" }}
                >
                  <Typography
                    className={
                      step.stepFont === "light" ? "font-white" : "font-black"
                    }
                    style={{
                      transform: "rotate(180deg)",
                      writingMode: "vertical-lr"
                    }}
                    variant="h3"
                    fontWeight={700}
                    textTransform="uppercase"
                  >
                    <span style={{ textDecoration: "underline" }}>{`Step ${index + 1}:`}</span>{` ${step.stepTitle}`}
                  </Typography>
                </Button>
              </Stack>}
          </Stack>
        );
      })}
    </Stack>
  );
};
export default CreateEventStepper;
